export const logo = require("./logo-fin.png");
export const profileimg = require("./profile.jpg");
export const menu_section_left = require("./menu_section_left.png");
export const food = require("./food_item.jpg");